// import SecurityTabContent from '@src/views/pages/account-settings/SecurityTabContent'
// import BillingTabContent from '@src/views/pages/account-settings/BillingTabContent'
// import NotificationsTabContent from '@src/views/pages/account-settings/NotificationsTabContent'
// import ConnectionsTabContent from '@src/views/pages/account-settings/ConnectionsTabContent'
import { lazy } from 'react'
import { Navigate } from 'react-router'

const Faq = lazy(() => import('../../views/pages/faq'))
const Profile = lazy(() => import('../../views/pages/profile'))
const Error = lazy(() => import('../../views/pages/misc/Error'))
const ComingSoon = lazy(() => import('../../views/pages/misc/ComingSoon'))
const Maintenance = lazy(() => import('../../views/pages/misc/Maintenance'))
const AccountSettings = lazy(() => import('../../views/pages/account-settings'))
const NotAuthorized = lazy(() => import('../../views/pages/misc/NotAuthorized'))

const PagesRoutes = [
  {
    path: '/pages/profile',
    element: <Profile />
  },
  {
    path: '/pages/faq', 
    element: <Faq />
  },
  {
    path: '/pages/account-settings',
    element: <AccountSettings /> // Main Account Settings with Account tab active
  },
  {
    path: '/pages/account-settings-security',
    element: <AccountSettings /> // Same component, Security tab active
  },
  // {
  //   path: '/pages/account-settings-billing', 
  //   element: <AccountSettings /> // Same component, Billing tab active
  // },
  // {
  //   path: '/pages/account-settings-notifications',
  //   element: <AccountSettings /> // Same component, Notifications tab active  
  // },
  // {
  //   path: '/pages/account-settings-connections',
  //   element: <AccountSettings /> // Same component, Connections tab active
  // },
  // {
  //   path: '/pages/blog/detail',
  //   element: <Navigate to='/pages/blog/detail/1' />
  // },
  // {
  //   path: '/pages/blog/edit',
  //   element: <Navigate to='/pages/blog/edit/1' />
  // },
   {
    path: '/misc/coming-soon',
    element: <ComingSoon />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/not-authorized',
    element: <NotAuthorized />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/maintenance',
    element: <Maintenance />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  },
  {
    path: '/misc/error',
    element: <Error />,
    meta: {
      publicRoute: true,
      layout: 'blank'
    }
  }
]

export default PagesRoutes